import { OverflowMenu } from "@carbon/react";
import { NullableTableColumns } from "@flaminem/ui-components";
import React from "react";

import { HeadlessWidget } from "src/dynamic-view-renderer/headlessWidgets/HeadlessWidget.typings";
import { HeadlessWidgetRenderer } from "src/dynamic-view-renderer/headlessWidgets/HeadlessWidgetRenderer";
import { CaseListTableConfig } from "src/types/case";
import { CustomerSummary } from "src/types/customer";

export const useGetColumns = ({
  customerListTable,

  headlessWidgets,
}: {
  customerListTable?: CaseListTableConfig;
  headlessWidgets: HeadlessWidget[];
}) => {
  const columns: NullableTableColumns<CustomerSummary> = React.useMemo(() => {
    // Find the case type configuration

    const dynamicColumns = customerListTable!.columns.reduce((acc, column) => {
      const widget = headlessWidgets.find((w) => w.code === column.headlessWidgetCode);
      if (!widget) return acc;

      return {
        ...acc,
        [column.headlessWidgetCode]: {
          label: column.headerLabel,
          flexGrow: 1,
          flexShrink: 1,
          width: column.width || 1,
          className: "text-sm",
          render: (row: CustomerSummary) => (
            <HeadlessWidgetRenderer
              widget={widget}
              data={{
                root: row,
                elements: row.elements,
                propertyValues: row.properties,
              }}
            />
          ),
          sorter: column.sorter,
        },
      };
    }, {});

    // Add actions column
    return {
      ...dynamicColumns,
      actions: {
        label: "",
        width: 80,
        render: (row) => (
          <div key={row.id} id={row.id}>
            <OverflowMenu flipped={true} onClick={(e) => e.stopPropagation()}>
              <></>
            </OverflowMenu>
          </div>
        ),
      },
    };
  }, [customerListTable, headlessWidgets]);
  return columns;
};
